import React from "react";
import cn from "classnames";
import styles from "./MarketplaceActivity.module.sass";
import { Link } from "react-router-dom";

const Row = ({ data, open }) => {
	return (
		<div className={styles.row}>
			<div
				className={styles.col}
				onClick={() => open({ _id: data.product.nft })}
			>
				<div className={styles.detail}>
					{/* <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQL7QvP9O28r_NBIFSihlqyq41QGhPKrrDGPrpGGsPGIYBXesb2EhANzd5yTLVoAg70BAA&usqp=CAU" /> */}
					<div>
						<div>{data.product?.name}</div>
					</div>
				</div>
			</div>
			<div className={cn(styles.col, styles.wide)}>
				<Link
					className={styles.link}
					to={`/customers/list/customer/${data.from?._id}`}
				>
					{data.from?.userName}
				</Link>
			</div>
			<div className={cn(styles.col, styles.wide)}>
				<Link
					className={styles.link}
					to={`/customers/list/customer/${data.from?._id}`}
				>
					{data.to?.userName}
				</Link>
			</div>
			<div className={styles.col}>
				{data.amount} {data.currency}
			</div>
			<div className={styles.col}>{new Date().toLocaleDateString()}</div>
		</div>
	);
};

export default Row;
